import React from 'react';

import {
  Text,
  TextAlignment,
  TokenTextAppearance,
  styled,
} from '@volkswagen-onehub/components-core';
import PhoneWallbox from './phone-wallbox';
import {Steps} from './app-screen';
import SpaceLike from '../components/Space';
import useMediaQuery from '../hooks/useMediaQuery';
import {motion} from 'framer-motion';
import {headingVariants, subheadingVariants} from './animations';
import {ContinueButton} from './common-components';
import {useSendAmpChargeAnalytic} from '../hooks/useSendAmpChargeAnalytic';

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > div > * {
    color: #fff;
  }
`;

const StyledText = styled(Text)`
  color: white;
  margin-bottom: 24px;
`;

type Props = {
  setStep: (step: Steps) => void;
  isCustomers?: boolean;
};

const IntroStep: React.FC<Props> = ({setStep, isCustomers}) => {
  const {isMobile} = useMediaQuery();
  const {handleContinueIntroClick} = useSendAmpChargeAnalytic();

  const onContinueClick = () => {
    setStep(Steps.WALKTHROUGH);
    handleContinueIntroClick();
  };

  return (
    <SpaceLike
      direction="vertical"
      customStyles={{
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'scroll',
        paddingTop: '24px',
        paddingBottom: 'calc(50px + env(safe-area-inset-bottom))',
        overflowX: 'hidden',
      }}
      width={'100%'}
      size={isMobile ? 24 : 48}
    >
      <PhoneWallbox />
      <TextContainer>
        <motion.div
          variants={headingVariants}
          initial="initial"
          animate="animate"
        >
          <Text
            appearance={TokenTextAppearance.headline300}
            textAlign={TextAlignment.center}
          >
            {isCustomers ? 'Ready to get' : 'Pull up and'}
          </Text>
        </motion.div>
        <motion.div
          variants={headingVariants}
          initial="initial"
          animate="animate"
        >
          <Text
            appearance={TokenTextAppearance.headline300}
            textAlign={TextAlignment.center}
            bold
          >
            {isCustomers ? 'powered up?' : 'get powered up'}
          </Text>
        </motion.div>
      </TextContainer>
      <motion.div
        variants={subheadingVariants}
        initial="initial"
        animate="animate"
      >
        <StyledText
          appearance={TokenTextAppearance.copy200}
          textAlign={TextAlignment.center}
        >
          {isCustomers ? (
            <span>
              This AR Experience will help you find your best home charging
              setup. You’ll then be able to snap some photos that can be used to
              complete your future AmpCharge EV charger installation
              application.
            </span>
          ) : (
            <span>
              This AR experience will visualise how our AmpCharge EV charger
              would look at your home. Just follow the on-screen instructions to
              get started.
            </span>
          )}
        </StyledText>
      </motion.div>
      <ContinueButton
        onClick={onContinueClick}
        emphasis="secondary"
        tag="button"
      >
        Continue
      </ContinueButton>
    </SpaceLike>
  );
};

export default IntroStep;
